import LoadHRDFCard from './LoadHRDFCard';
import FromScratchCard from './FromScratchCard';

export default [
  LoadHRDFCard,
  FromScratchCard,
];
